'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.RichEditor = void 0;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of'),
    _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf),
    _classCallCheck2 = require('babel-runtime/helpers/classCallCheck'),
    _classCallCheck3 = _interopRequireDefault(_classCallCheck2),
    _createClass2 = require('babel-runtime/helpers/createClass'),
    _createClass3 = _interopRequireDefault(_createClass2),
    _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn'),
    _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2),
    _inherits2 = require('babel-runtime/helpers/inherits'),
    _inherits3 = _interopRequireDefault(_inherits2),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _draftJs = require('draft-js');

require('react-draft-wysiwyg/dist/react-draft-wysiwyg.css');

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var Editor = function Editor() {
  return null;
},
    draftToHtml = function draftToHtml() {
  return null;
},
    htmlToDraft = function htmlToDraft() {
  return null;
};

if ('undefined' != typeof window) var _require = require('react-draft-wysiwyg'),
    _Editor = _require.Editor,
    _draftToHtml = require('draftjs-to-html').default,
    _htmlToDraft = require('html-to-draftjs').default; // https://jpuri.github.io/react-draft-wysiwyg/#/docs

var RichEditor = exports.RichEditor = function (a) {
  function b(a) {
    (0, _classCallCheck3.default)(this, b);
    var c = (0, _possibleConstructorReturn3.default)(this, (b.__proto__ || (0, _getPrototypeOf2.default)(b)).call(this, a)),
        d = void 0;

    if ('value' in a && !!a.value) {
      var e = htmlToDraft(a.value),
          f = _draftJs.ContentState.createFromBlockArray(e.contentBlocks);

      d = _draftJs.EditorState.createWithContent(f);
    } else d = _draftJs.EditorState.createEmpty();

    return c.state = {
      editorState: d
    }, c.setEditorState = c.setEditorState.bind(c), c.onBlur = c.onBlur.bind(c), c;
  }

  return (0, _inherits3.default)(b, a), (0, _createClass3.default)(b, [{
    key: 'setEditorState',
    value: function b(a) {
      this.setState({
        editorState: a
      });
    }
  }, {
    key: 'onBlur',
    value: function a() {
      'setValue' in this.props && this.props.setValue(draftToHtml((0, _draftJs.convertToRaw)(this.state.editorState.getCurrentContent())));
    }
  }, {
    key: 'render',
    value: function a() {
      return _react2.default.createElement(Editor, {
        editorState: this.state.editorState,
        wrapperStyle: {
          border: '1px solid lightgrey',
          padding: '10'
        },
        onEditorStateChange: this.setEditorState,
        onBlur: this.onBlur
      });
    }
  }]), b;
}(_react2.default.Component);